// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"537bb7ac","44":"7f206f3b","61":"c73f1431","411":"a97c0dbb","486":"7a7c5ebb","495":"37a97fa0","569":"9c0a9167","584":"4545f1b6","668":"569f0ad4","747":"fb66ab24","852":"b83bd27d","922":"0d0e87cd","934":"a894be6f"}[chunkId] + ".chunk.js";
};